"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var is_type_1 = require("./is-type");
exports.default = (function (str) {
    return is_type_1.default(str, 'String');
});
//# sourceMappingURL=is-string.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/lib/is-string.js
// module id = 264
// module chunks = 37